import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  watch: {
    chartData() {
      this.$data._chart.update()
    }
  },
  mounted() {
    this.renderChart(this.chartdata, this.options)
  }
}


// WEBPACK FOOTER //
// ./src/components/ChartComponents/BarChart.js